/**
 * Vidéos de la colonne d'achat (snippets/tiloa-product-videos.liquid).
 * Le défilement est natif (scroll-snap) ; ce script ne fait que piloter les
 * flèches, et les masque quand toutes les vidéos tiennent déjà à l'écran.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-pvideos-track]');
    var nav = root.querySelector('[data-pvideos-nav]');
    var prev = root.querySelector('[data-pvideos-prev]');
    var next = root.querySelector('[data-pvideos-next]');
    if (!track) return;

    function pas() {
      var item = track.querySelector('.tiloa-pvideos__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function maj() {
      var max = track.scrollWidth - track.clientWidth;
      var deborde = max > 2;
      if (nav) nav.hidden = !deborde;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pas(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  }

  function initAll() { document.querySelectorAll('[data-tiloa-pvideos]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
